import api from 'utils/api';
import {WORKERS} from 'constants/accounts';

// Actions
const SET_PRODUCT = 'PRODUCT_DETAIL/SET_PRODUCT';
const SET_WORKERS = 'PRODUCT_DETAIL/SET_WORKERS';
const SET_ERROR = 'PRODUCT_DETAIL/SET_ERROR';
const SET_LOADING = 'PRODUCT_DETAIL/SET_LOADING';

// Initial state for reducer
const initialState = {
    product: null,
    error: null,
    isLoading: false,
    workers: [],
};

// Reducer(s)
export default function componentsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PRODUCT:
            return {
                ...state,
                product: action.response.data,
                error: null,
                isLoading: false,
            };
        case SET_WORKERS:
            return {...state, workers: action.workers};
        case SET_ERROR:
            return {...state, product: null, error: action.error, isLoading: false};
        case SET_LOADING:
            return {...state, product: null, isLoading: action.isLoading};
        default:
            return state;
    }
}

// Action creators
const setProduct = response => ({type: SET_PRODUCT, response});
const setError = error => ({type: SET_ERROR, error});
const setLoading = isLoading => ({type: SET_LOADING, isLoading});
const setWorkers = workers => ({type: SET_WORKERS, workers});


const fetchProduct = (currentProduct, action, dispatch) => {
    dispatch(setLoading(true));
    api.productionProductDetail.fetch({pk: currentProduct}).then(
        data => dispatch(action({data, currentProduct})),
        (error) => {
            let message = gettext("Loading components failed");
            if (error.statusCode === 403) {
                try {
                    message = JSON.parse(error.responseText).detail;
                } catch (e) {
                    // Display the default message
                }
            }
            dispatch(setError(message));
        },
    );
};

const fetchWorkers = (dispatch, role) => {
    api.accountsUserList.fetch(null, {role}).then(
        data => dispatch(setWorkers(data.results)),
        () => {
            dispatch(setError(gettext("Loading workers failed")));
        },
    );
};

export const refreshProduct = productId => (dispatch, getState) => {
    fetchProduct(productId, setProduct, dispatch);

    if (getState().workers.worker.role === WORKERS.ROLES.BUNDLER.value) {
        // Since most workers do not need to see other workers with the same
        // role, we can just fetch them only when they are needed.
        fetchWorkers(dispatch, getState().workers.worker.role);
    }
};



// WEBPACK FOOTER //
// ./src/ducks/productDetail.js